import React from 'react';
import UploadSection from 'sub_components/Common/UploadSection';
import styled from 'styled-components';

const AddAttachmentsStyle = styled.div`
	.attachment-display-section {
		border-top: 1px solid gray;
		padding-top: 1vh;
		border-radius: 0px;
		.attachment-row {
			display: flex;
			flex-direction: row;
			height: 4vw;
			padding: 0 1vw;
			margin-bottom: 1vh;

			.progress-icon {
				flex: 0 1 4vw;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				height: 100%;
				border: 1px solid #563f6c;
				background-color: #563f6c;

				.progress-background {
					width: 3vw;
					height: 3vw;
				}

				.animated-progress {
					position: absolute;
					width: 3vw;
					height: 3vw;
					stroke-dasharray: 1000;
					// stroke-dashoffset: 2;
				}

				svg {
					position: absolute;
					width: 3vw;
					height: 3vw;

					.indicator {
						transition: stroke-dashoffset 1s;
						transform-origin: center center;
						transform: rotate(-90deg);
						stroke-dasharray: 220;
						stroke-dashoffset: 220;
					}
				}

				@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
					svg {
						margin-top: -2.9vh;
					}
				}
			}

			.file-name {
				flex: 0 1 70%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: flex-end;
				@include Text-Style-61;
				text-align: left;
				color: gray;
				padding-bottom: 0.5vh;
				padding-left: 0.3vw;
			}

			.status {
				flex: 0 1 20%;
				display: flex;
				flex-direction: column;
				justify-content: flex-end;
				align-items: center;
				height: 100%;
				text-align: center;
				opacity: 0;
				transition: opacity 0.5s;

				img {
					width: 40%;
					height: 40%;
				}

				.file-size {
					text-align: center;
					color: $DCBLOX_Gray;
				}
			}
		}

		.attachment-row.scanned-successfully {
			.indicator {
				stroke-dashoffset: 0 !important;
			}
			.status {
				opacity: 1 !important;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const AddAttachments = ({
	cypressId,
	id,
	attachments,
	auth_status,
	phase,
	saveAttachments,
	//renderAttachments,
	error,
	//existingAttachments,
}) => {
	return (
		<AddAttachmentsStyle id={id} className={`attachment-screen`} data-cy={cypressId}>
			{error && <div className='error'>Error: {error}</div>}

			{/* <div className='attachment-display-section'>
				{existingAttachments.length > 0 && renderAttachments()}
			</div> */}
			<div className='attachment-section'>
				<UploadSection
					saveAttachments={saveAttachments}
					phase={phase}
					attachments={attachments}
					auth_status={auth_status}
					type='comment'
				/>
			</div>
		</AddAttachmentsStyle>
	);
};
